import IconButton from 'src/components/IconButton';
import IconTextButton from 'src/components/IconTextButton';

import { Container, DocIconContainer, IconContainer, MintscanIconContainer, RightContainer } from './styled';

import { ReactComponent as Burger32Icon } from 'src/assets/svg/Burger32.svg';
import { ReactComponent as Doc } from 'src/assets/svg/Doc.svg';
import { ReactComponent as MintscanIcon } from 'src/assets/svg/MintscanSwap.svg';

type HeaderProps = {
  onClick: () => void;
};

export default function Header({ onClick }: HeaderProps) {
  return (
    <Container>
      <MintscanIconContainer>
        <MintscanIcon />
      </MintscanIconContainer>

      <RightContainer>
        <IconTextButton
          icon={
            <DocIconContainer>
              <Doc />
            </DocIconContainer>
          }
          text="GUIDE"
          typoVarient="h14"
          onClick={onClick}
        />
        <IconButton onClick={onClick}>
          <IconContainer>
            <Burger32Icon />
          </IconContainer>
        </IconButton>
      </RightContainer>
    </Container>
  );
}
